import ical from 'ical.js'

const MAX_HOLIDAY_NAME_LENGTH = 80

export class ICalParser {

    parseHolidays(file, year, successCallback, errorCallback) {
        let reader = new FileReader()

        reader.onload = () => {
            let icalData = reader.result

            try {
                successCallback(this.parseHolidayFromText(icalData, year))
            } catch (error) {
                errorCallback(error)
            }
        }

        reader.readAsText(file)
    }

    parseHolidayFromText(text, year) {
        let data = ical.parse(text)
        let comp = new ical.Component(data);

        let allICalHolidays = comp.getAllSubcomponents("vevent")
        let allHolidays = []

        allICalHolidays
        .filter((event) => {
            return new Date(event.getFirstPropertyValue("dtstart").year,
                            event.getFirstPropertyValue("dtstart").month - 1,
                            event.getFirstPropertyValue("dtstart").day).getFullYear() === year
        })
        .forEach((event) => {
            let icalTimeStart = event.getFirstPropertyValue("dtstart")
            let icalTimeEnd = event.getFirstPropertyValue("dtend")

            let dayStart = new Date(icalTimeStart.year, icalTimeStart.month - 1, icalTimeStart.day)
            let dayEnd = new Date(icalTimeEnd.year, icalTimeEnd.month - 1, icalTimeEnd.day)

            for (let iteratorDate = dayStart; iteratorDate < dayEnd; iteratorDate.setDate(iteratorDate.getDate() + 1)) {
                let name = this.createValidString(event.getFirstPropertyValue("summary"))

                allHolidays.push({
                    date: new Date(iteratorDate),
                    name: name
                })
            }
        })

        return allHolidays
    }

    createValidString(string) {

        if (string.length > MAX_HOLIDAY_NAME_LENGTH) {
            return string.substring(0, MAX_HOLIDAY_NAME_LENGTH)
        }

        return string
    }
}


// WEBPACK FOOTER //
// ./web/js/parsers/ical/ICalParser.js